import { render, staticRenderFns } from "./alarmHistory.vue?vue&type=template&id=63f76c79&scoped=true&"
import script from "./alarmHistory.vue?vue&type=script&lang=js&"
export * from "./alarmHistory.vue?vue&type=script&lang=js&"
import style0 from "./alarmHistory.vue?vue&type=style&index=0&id=63f76c79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f76c79",
  null
  
)

export default component.exports